module.exports = __webpack_public_path__ + "h5/static/img/bit-bank-hk-logo.427752b7.png";